export default __webpack_public_path__ + "static/media/checkBoxes.9e243e7c.svg";